// Profile Information Schema - First stage of onboarding
// This collects basic user profile information before moving to business/context information
const profileSchema = [
  {
    "title": "name",
    "type": "string",
    "content": {
      "label": "First Name",
      "helpText": "What is your first name?",
      "validation": {
        "required": true,
        "minLength": 2
      }
    }
  },
  {
    "title": "surname",
    "type": "string",
    "content": {
      "label": "Last Name",
      "helpText": "What is your last name?",
      "validation": {
        "required": true,
        "minLength": 2
      }
    }
  },
  {
    "title": "mobile",
    "type": "phone",
    "content": {
      "label": "Phone Number",
      "helpText": "What is your phone number?"
    }
  },
  {
    "title": "job_title",
    "type": "string",
    "content": {
      "label": "Job Title",
      "helpText": "What is your job title or position?",
    }
  },
  {
    "title": "department",
    "type": "string",
    "content": {
      "label": "Department",
      "helpText": "Which department do you work in?",
    }
  },
  {
    "title": "city",
    "type": "string",
    "content": {
      "label": "City",
      "helpText": "Which city are you located in?",
    }
  },
  {
    "title": "country",
    "type": "string",
    "content": {
      "label": "Country",
      "helpText": "Which country are you located in?",
  }
}
];

export default profileSchema;















